// extracted by mini-css-extract-plugin
export default {"input__search":"SearchBar_input__search__0Mp9H"};